import { combineReducers } from '@reduxjs/toolkit';
import gameReducer from './slices/gameSlice';
import uiReducer from './slices/uiSlice';
import worldReducer from './slices/worldSlice';
import encryptidsReducer from './slices/encryptidsSlice';
import resourcesReducer from './slices/resourcesSlice';
import operatorReducer from './slices/operatorSlice';
import facilitiesReducer from './slices/facilitiesSlice';
import missionsReducer from './slices/missionsSlice';
import needsReducer from './slices/needsSlice';

const rootReducer = combineReducers({
  game: gameReducer,
  ui: uiReducer,
  world: worldReducer,
  encryptids: encryptidsReducer,
  resources: resourcesReducer,
  operators: operatorReducer,
  facilities: facilitiesReducer,
  missions: missionsReducer,
  needs: needsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;